import type { TestValues } from '../types'
import type { NotificationFormType } from '@/notificationForms'

import { Modal } from '@/components/Modal'

import { modalId } from '../hooks/useController'
import { Content } from './Content'

interface Props {
  notification: NotificationFormType
  values: TestValues
}

export function Root(props: Props) {
  return (
    <Modal modalId={modalId}>
      <Content {...props} />
    </Modal>
  )
}
